import React from 'react';
import FadeIn from '../components/ui/FadeIn';

const Booking = () => {
  return (
    <div className="pt-40 pb-24 bg-brand-bone min-h-screen">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center mb-20">
          <FadeIn>
            <h1 className="text-6xl md:text-8xl font-heading mb-8">Book your <span className="serif-italic text-brand-orange">session.</span></h1>
            <p className="text-xl opacity-70">
              Simple, seamless, and designed to get you creating quickly. Choose your service, select your time, and we’ll take care of the rest.
            </p>
          </FadeIn>
        </div>

        <FadeIn className="bg-white rounded-[2rem] overflow-hidden shadow-2xl">
          <iframe 
            src="https://lbbrandhaus.nuvoro.net" 
            width="100%" 
            height="800" 
            frameBorder="0" 
            title="Book an appointment"
            className="w-full"
            loading="lazy"
          ></iframe>
        </FadeIn>
      </div>
    </div>
  );
};

export default Booking;